module.exports = __webpack_public_path__ + "media/icons/offer-details-osobowe@3x-55b1ccb8.svg";